import axios from '../../utils/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const getClinicFeatures = (clinicId) =>
    axios.get(`${API_URL}clinics/${clinicId}/features`);

const clinicFeaturesService = {
    getClinicFeatures,
};

export default clinicFeaturesService;
